"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const moment = require("moment");
/**
 * Sanity check to ensure we have a dateFormat.
 */
exports.default = (value, options) => {
    if (!options.dateFormat) {
        return "^Internal error";
    }
    if (_.isString(value) && !moment(value, options.dateFormat, true).isValid()) {
        return "^The date is incomplete";
    }
};
//# sourceMappingURL=dateFormat.js.map